// removed by extract-text-webpack-plugin
module.exports = {"magazine-content":"magazines_cJwa9"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Editor/styles.scss
// module id = 1054
// module chunks = 1